import { useState, useEffect } from 'react';
import Button from '../Button';
import styles from './styles.module.scss';


const CookieConsent = () => {
	const [isVisible, setIsVisible] = useState(false);
	// Use location to re-check if needed, though local state is enough for single instance

	useEffect(() => {
		const consent = document.cookie
			.split('; ')
			.find((row) => row.startsWith('maneliada_cookie_consent='));

		if (consent) {
			// Already consented, activate tracking
			activateScripts();
		} else {
			setIsVisible(true);
		}
	}, []);

	const activateScripts = () => {
		const scripts = document.querySelectorAll('script[type="text/plain"][data-consent="true"]');
		scripts.forEach((script) => {
			const newScript = document.createElement('script');
			newScript.type = 'text/javascript';
			// Copy attributes
			Array.from(script.attributes).forEach(attr => {
				if (attr.name !== 'type' && attr.name !== 'data-consent') {
					newScript.setAttribute(attr.name, attr.value);
				}
			});

			if ((script as HTMLScriptElement).src) {
				newScript.src = (script as HTMLScriptElement).src;
			} else {
				newScript.innerHTML = script.innerHTML;
			}

			document.head.appendChild(newScript);
			// Remove the placeholder to avoid confusion/clutter
			script.parentNode?.removeChild(script);
		});
	};

	const handleAccept = () => {
		document.cookie = 'maneliada_cookie_consent=true; max-age=31536000; path=/; SameSite=Lax';
		activateScripts();
		setIsVisible(false);
	};

	const handleDecline = () => {
		document.cookie = 'maneliada_cookie_consent=false; max-age=2592000; path=/; SameSite=Lax';
		setIsVisible(false);
	};

	if (!isVisible) return null;

	return (
		<aside className={styles.cookieWrapper} role="region" aria-label="Consimțământ cookie-uri">
			<div className={styles.content}>
				Folosim module cookie pentru a îmbunătăți experiența pe site și a analiza traficul. Prin acceptare, ești de acord cu utilizarea tehnologiilor noastre de analiză.
			</div>
			<div className={styles.actions}>
				<Button
					label="Refuză"
					ariaLabel="Refuză cookie-urile non-esențiale"
					onClick={handleDecline}
					customStyles={{ backgroundColor: 'transparent', border: '1px solid #efa43b', color: '#efa43b' }}
				/>
				<Button
					label="Acceptă"
					ariaLabel="Acceptă toate cookie-urile"
					onClick={handleAccept}
				/>
			</div>
		</aside>
	);
};

export default CookieConsent;
